import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { v7 as uuidv7 } from 'uuid';

import type { InviteEntryPoint } from '@/features/RenterInvite/RenterInvite.types';

type InviteTrackingProviderProps = {
  children: ReactNode;
  entryPoint?: InviteEntryPoint | null;
};

type InviteTrackingContextValue = {
  flowId: string;
  entryPoint?: InviteEntryPoint | null;
};

const InviteTrackingContext = createContext<InviteTrackingContextValue | null>(null);

export const InviteTrackingProvider = ({ children, entryPoint }: InviteTrackingProviderProps) => {
  const [flowId] = useState(() => uuidv7());
  const value = useMemo(() => ({ flowId, entryPoint }), [flowId, entryPoint]);

  return <InviteTrackingContext.Provider value={value}>{children}</InviteTrackingContext.Provider>;
};

export const useInviteTrackingContext = () => useContext(InviteTrackingContext);
